export default {
  setString(state, payload) {
    state.string = payload;
  },
  setCategory(state, payload) {
    state.category = payload;
  },
  setData(state, { data }) {
    if (data) {
      state.data = data;
    } else {
      state.data = {};
    }
  },
  setAutocompleteSource(state, payload) {
    state.autocompleteSource = payload;
  },
  resetAutocomplete(state) {
    state.category = null;
    state.string = '';
    state.data = {};
    state.autocompleteSource = null;
    state.searchParams = {
      limit: 50,
      offset: 0,
    };
  },
};
